<div class="toggle-button-area">
    <label class="toggle-label">{{ switchLabel }}&nbsp;&nbsp;</label>
    <kendo-switch
        [(ngModel)]="checked"
        (click)="switchHandle($event)"
        [ngClass]="checked ? 'kendo-switch-on' : 'kendo-switch-off'"
    >
    </kendo-switch>
</div>
